import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, ExternalLink } from "lucide-react";
import { PageHero } from "@/components/site/PageHero";
import { Reveal } from "@/components/site/Reveal";
import { api, resolveImg } from "@/lib/api";
import { useSettings } from "@/lib/settings";
import { CATALOG_URL } from "@/lib/data";

export default function Shop() {
  const { settings } = useSettings();
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    api.get("/shop").then(({ data }) => setProducts(data)).catch(() => setProducts([]));
    api.get("/categories").then(({ data }) => setCategories(data)).catch(() => setCategories([]));
  }, []);

  return (
    <div data-testid="shop-page">
      <PageHero eyebrow="SHOP THE COLLECTION" title="EVERYTHING CUSTOM" script="printed your way" />
      <section className="py-16 bg-paper">
        <div className="max-w-[1280px] mx-auto px-5 lg:px-8">
          <div className="flex flex-wrap gap-3 mb-8">
            {categories.map((c) => (
              <span key={c.key} className="px-5 py-2 border border-navy/20 text-sm tracking-[0.08em] text-navy hover:bg-navy hover:text-white transition-colors cursor-pointer">{c.label}</span>
            ))}
          </div>

          <div className="bg-ink text-[#f2f0ea] px-6 py-5 mb-12 flex flex-wrap items-center justify-between gap-4">
            <p className="text-sm text-white/80">Want to see every style, color, and brand we can print on? Explore our complete apparel catalog.</p>
            <a
              href={CATALOG_URL}
              target="_blank"
              rel="noreferrer"
              data-testid="shop-catalog-button"
              className="inline-flex items-center gap-2 bg-gold text-ink px-6 py-3 text-xs font-bold tracking-[0.14em] hover:bg-gold-soft transition-colors whitespace-nowrap"
            >
              BROWSE FULL CATALOG <ExternalLink size={15} />
            </a>
          </div>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
            {products.map((p, i) => (
              <Reveal key={p.id || p.label} delay={(i % 4) * 0.08}>
                <div className="group" data-testid={`product-${i}`}>
                  <div className="relative aspect-square overflow-hidden bg-[#e9e6dd] mb-3">
                    <img src={resolveImg(p.img)} alt={p.label} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
                  </div>
                  <div className="flex items-center justify-between">
                    <div>
                      <div className="font-semibold text-sm">{p.label}</div>
                      {settings.show_prices && p.price ? (
                        <div className="text-navy/60 text-xs mt-0.5" data-testid={`product-price-${i}`}>from ${p.price}</div>
                      ) : null}
                    </div>
                    <Link to="/quote" className="text-navy hover:text-gold transition-colors shrink-0"><ArrowUpRight size={18} /></Link>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
          <div className="text-center mt-16">
            <Link to="/quote" className="inline-block bg-ink text-[#f2f0ea] px-10 py-4 text-[13px] font-bold tracking-[0.18em] hover:bg-navy transition-colors">REQUEST A CUSTOM QUOTE</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
